var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noAuthority"},[_c('div',{staticClass:"SkipTip"},[_vm._v("\n    "+_vm._s(_vm.$t('lang.noPerimission'))),_c('span',{on:{"click":_vm.LoginOut}},[_vm._v(_vm._s(_vm.$t('lang.gotoLoginPage')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }